module.exports = __webpack_public_path__ + "img/set-complet-angel.57e45639.jpg";